import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://flightapi.sellenvo.com'
})

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    if (!config.headers) config.headers = {
      common: {}
    }
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})


export default apiClient

